import React from 'react';
import {
  TableBody,
  TableHead,
  TableHeadCell,
  TableContainer,
} from '../../../../../components/tableComponents';
import ReportTableBodyRow from './ReportTableBodyRow/ReportTableBodyRow';

export const reportTableComponents = {
  table: (props) => <TableContainer {...props} />,
  header: {
    wrapper: TableHead,
    cell: TableHeadCell,
  },
  body: {
    wrapper: TableBody,
    row: ({ colCount, record, expandedRowRender, expanded, ...props }) => {
      const isService = props['data-row-key'].split('_')[0] === 'service';

      return (
        <ReportTableBodyRow
          {...props}
          isExpanded={expanded}
          isClickable={isService}
        />
      );
    },
  },
};
